import axios, { AxiosError, AxiosResponse } from 'axios';
import { TrackingEvents } from '../dataTransformation/tracking';
import getVersionWebview from '../navigation/controlVersion';

const { trackingApiRequest } = new TrackingEvents();

const ApisClient = axios.create({
    baseURL: '/be/apis',
    withCredentials: true,
    headers: {
        'Content-type': 'application/json',
        'X-App-Info': getVersionWebview(),
    },
});

ApisClient.interceptors.response.use(
    (response: AxiosResponse) => {
        trackingApiRequest(response, 'SUCCESS');
        return response;
    },
    (error: AxiosError) => {
        trackingApiRequest(error, 'ERROR');
        return Promise.reject(error);
    },
);

export const ApisClientNoLoader = axios.create({
    baseURL: '/be/apis',
    withCredentials: true,
    headers: {
        'Content-type': 'application/json',
        'X-App-Info': getVersionWebview(),
    },
});

ApisClientNoLoader.interceptors.response.use(
    (response: AxiosResponse) => {
        trackingApiRequest(response, 'SUCCESS');
        return response;
    },
    (error: AxiosError) => {
        trackingApiRequest(error, 'ERROR');
        return Promise.reject(error);
    },
);

export default ApisClient;
